document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-characteristics-tabs]');
  if (!container) return;

  const swiperElement = container.querySelector('[data-nav-swiper]');
  if (!swiperElement) return;

  // Initialize Swiper
  const characteristicsSwiper = new Swiper(swiperElement, {
    freeMode: true,
    slidesPerView: 'auto',
    spaceBetween: 12,
    grabCursor: true,
    scrollbar: {
      el: container.querySelector('.swiper-scrollbar'),
      draggable: true,
      hide: false,
    },
    watchOverflow: true
  });

  const buttons = container.querySelectorAll('.characteristic-tab-btn');
  const panels = container.querySelectorAll('[data-panel]');

  // Tab Toggle Logic
  buttons.forEach(button => {
    button.addEventListener('click', (e) => {
      // Prevent tab switch if dragging
      if (characteristicsSwiper.animating) return;

      const targetId = button.getAttribute('data-target');
      
      // Update buttons
      buttons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Update panels
      panels.forEach(panel => {
        panel.classList.toggle('active', panel.id === targetId);
      });

      // Center the clicked slide
      const slide = button.closest('.swiper-slide');
      if (slide) {
        characteristicsSwiper.slideTo(Array.from(slide.parentNode.children).indexOf(slide));
      }
    });
  });
});
